import axios from "axios";
import Card from "components/card";
import React, { useEffect, useState } from "react";
import InputField from "components/fields/InputField";
import CustomButton from "components/button/custom_button";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { currentUser } from "services/users/authSlice";
import { MdDelete } from "react-icons/md";
import ApiList from "services/apiList";
import Select from "components/select";
import Badge from "components/badge";
import Modal from "components/modal";
import Loader from "components/loader";

const typeOptions = [
  { value: 1, label: "2-3 нас" },
  { value: 2, label: "3-4 нас" },
];

const AngiBagtslahDetails = () => {
  const { id } = useParams();
  const user = useSelector(currentUser);
  const navigate = useNavigate();
  const [angiud, setAngiud] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedAngiud, setSelectedAngiud] = useState([]);
  const [bagtsNer, setBagtsNer] = useState("");
  const [type, setType] = useState(0);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true);
      try {
        const { data: response } = await axios.get(ApiList.getCourses);
        setAngiud(response.result);
      } catch (error) {
        alert("Сервертэй холбогдож чадсангүй");
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  useEffect(() => {
    if (id !== "new") {
      getData(id);
    }
  }, [id]);

  const getData = async (id) => {
    setLoading(true);
    try {
      const { data: response } = await axios.get(
        ApiList.getCourseBagts + `${id}/`
      );
      const result = response.result;

      setBagtsNer(result.name);
      setType(result.type);
      setSelectedAngiud(result.courses);
    } catch (error) {
      alert("Сервертэй холбогдож чадсангүй");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    if (!e.preventDefault()) {
      if (selectedAngiud.length === 0) {
        return alert("Анги сонгоно уу!");
      }

      setLoading(true);
      const courses = [];
      selectedAngiud.forEach((item) => {
        courses.push(item.id);
      });

      const payload = {
        id,
        title: bagtsNer,
        type,
        courses,
      };

      if (id === "new") {
        const response = await axios.post(ApiList.getCourseBagts, payload);

        const { status } = response.data;

        setLoading(false);
        if (status) {
          return navigate("/admin/angi-bagstlagh");
        }
      } else {
        const response = await axios.put(
          ApiList.getCourseBagts + `${id}/`,
          payload
        );

        const { status } = response.data;

        setLoading(false);
        if (status) {
          return navigate("/admin/angi-bagstlagh");
        }
      }
    }
  };

  const handleDelete = async (e) => {
    setLoading(true);
    const response = await axios.delete(ApiList.getCourseBagts + `${id}/`);

    const { status } = response.data;
    setLoading(false);
    if (status) {
      return navigate("/admin/angi-bagstlagh");
    }
  };

  const addAngi = (e) => {
    e.preventDefault();
    setSelectedAngiud((selected) => {
      var sCourse = [...selected];
      var value = JSON.parse(e.target.value);
      const isAdded = sCourse.findIndex(
        (item) => item.id.toString() === value.id.toString()
      );
      if (isAdded === -1) {
        sCourse.push(value);
      }
      return sCourse;
    });
  };

  const removeAngi = (index) => {
    setSelectedAngiud((selectedAngiud) => {
      var sAngi = [...selectedAngiud];
      sAngi.splice(index, 1);
      return sAngi;
    });
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <Card extra="mt-4 w-full bg-white p-5">
      <header className="relative flex items-center justify-end pt-4 lg:pr-20">
        {id !== "new" ? (
          <button
            className="rounded-lg bg-lightPrimary p-2 text-brand-500 !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10 block"
            onClick={() => setShowModal(true)}
          >
            <MdDelete className="h-6 w-6 fill-red-600" />
          </button>
        ) : null}
      </header>
      <div className="justify-start gap-5 lg:flex lg:px-20 lg:pb-20">
        <form onSubmit={handleSubmit}>
          <InputField
            required
            className="lg:w-96"
            label="Багцын нэр"
            pattern="^.{3,}$"
            placeholder="e.g. Ахлах бүлэг"
            errorMessage="Багцын нэр 3-с дээш тэмдэгтээс бүрдэнэ!"
            value={bagtsNer}
            onChange={(e) => setBagtsNer(e.target.value)}
          />

          {user.school.type === 1 && (
            <div className="mt-3">
              <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
                Төрөл сонгох
              </label>

              <br />
              <Select
                value={type}
                onChange={(e) => setType(e.target.value)}
                required
                defaultText="Төрөл сонгоно уу."
              >
                {typeOptions.map((option) => {
                  return (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  );
                })}
              </Select>
            </div>
          )}

          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Анги нэмэх
          </label>

          <br />

          {selectedAngiud.map((row, index) => {
            return (
              <Badge
                key={index}
                index={index}
                text={row.number + row.group}
                remove={removeAngi}
              />
            );
          })}
          <Select
            id="course"
            required={false}
            value=""
            defaultText="Анги сонгоно уу."
            className="mt-2"
            onChange={addAngi}
            children={angiud.map((row, index) => {
              const check = selectedAngiud.find((s) => s.id === row.id);
              if (!check) {
                return (
                  <option key={index} value={JSON.stringify(row)}>
                    {row.number}
                    {row.group}
                  </option>
                );
              }
              return null;
            })}
          />
          <CustomButton text="Хадгалах" type="submit" className="mr-3" />
          <CustomButton
            onClick={() => {
              window.history.back();
              //   navigate("/admin/angi-bagstlagh");
            }}
            text="Буцах"
            isBack={true}
          />
        </form>
        {showModal && id !== "new" ? (
          <Modal
            handleSubmit={handleDelete}
            setShowModal={setShowModal}
            child={
              <p className="text-xl text-navy-700 dark:text-white">
                Та "{bagtsNer}"-ыг устгахдаа итгэлтэй байна уу?
              </p>
            }
            title="Устгах"
          />
        ) : null}
      </div>
    </Card>
  );
};

export default AngiBagtslahDetails;
